import queryString from 'query-string';
import { PROJECT_HASH_PARAM } from '../constants/formParams';
import { PROJECT_REGISTRATION_KEY } from '../constants/sessionStorage';
/* eslint-disable */
export const createURL = (url: string): URL => {
  try {
    return new URL(url);
  } catch {
    const extended = `${location.protocol}//${location.hostname}${
      location.port ? ':' + location.port : ''
    }${url}`;
    return new URL(extended);
  }
};

export const getQueryParams = (url: string) => {
  return queryString.parse(url);
};

export const getBaseURL = () => window.location.origin;

export const getUrlLastPathValue = (url: string) => {
  if (!url) {
    return null;
  }

  const cleanedUrl = url.endsWith('/') ? url.slice(0, -1) : url;

  const parts = cleanedUrl.split('/');
  const lastPart = parts.pop() || null;
  return lastPart === 'create' ? null : lastPart;
};

export const getProjectKey = () => {
  const localStorageKey = localStorage.getItem(PROJECT_REGISTRATION_KEY);
  let projectKey = '';
  if (!localStorageKey) return null;
  const isQueryParamExist = localStorageKey.includes('?');

  if (isQueryParamExist) {
    const query = localStorageKey.split('?')[1];
    const params = queryString.parse('?' + query);
    projectKey = params['project-token'] as any;
  } else {
    projectKey = getUrlLastPathValue(localStorageKey);
  }

  return projectKey;
};
